module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0742.d0a46d46.jpg";